module.exports = __webpack_public_path__ + "img/momo_home_bg_8.60013d4a.png";